/* eslint-disable react-hooks/exhaustive-deps */

import { Box, ThemeProvider, createTheme } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { getVendorDetails, setVendorId } from 'modules/authorizations/store/actions/dataManagement.actions';

import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import VendorsDetails from './vendorsDetails.component';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { getVendorHistory, getAllVendorAuthNotes } from 'modules/authorizations/store/actions/dataManagement.actions';
import { GET_VENDOR_HISTORY_FAILURE } from 'modules/authorizations/store/types/dataManagementTypes';
import { getExpenseLineItems, getVoucherSummaries } from 'modules/expenses/store/expenses.actions';
import { GET_EXPENSE_LINES_FAILURE, GET_VOUCHER_SUMMARIES_BY_AUTH_FAILURE } from 'modules/expenses/store/types';
import {
  getAllCountries,
  getAllCurrencies,
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllWeightTypes
} from 'modules/enumerations/store/enumerationActions';
import { fetchEnumerations, fetchVendordetails } from 'modules/authorizations/utils/fetchDataDetailsService';
import { showToast } from 'modules/layout/layout.actions';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  }
});

const VendorDetailsView = props => {
  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  const [isLoading, setIsLoading] = useState(false);

  const details = props.vendorDetails ? props.vendorDetails[props.match.params.id] : null;

  useEffect(() => {
    async function fetchData() {
      const id = props.match.params.id;
      props.setVendorId(id);
      setIsLoading(true);

      await fetchVendordetails(details, id, props);
      await fetchEnumerations(props);

      let historyResp = await props.getVendorHistory(id);
      if (historyResp.type === GET_VENDOR_HISTORY_FAILURE) {
        props.showToast('Failed to retrieve vendor history, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }

      if (!props.voucherSummaries) {
        let { type } = await props.getVoucherSummaries();
        if (type === GET_VOUCHER_SUMMARIES_BY_AUTH_FAILURE) {
          props.showToast('Failed to retrieve vouchers, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        }
      }

      if (!props.expenseLines) {
        let { type } = await props.getExpenseLines();
        if (type === GET_EXPENSE_LINES_FAILURE) {
          props.showToast('Failed to retrieve expense lines, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        }
      }

      if (!props.vendorAuthNotes) {
        let { type } = await props.getAllVendorAuthNotes();
        if (type === GET_EXPENSE_LINES_FAILURE) {
          props.showToast('Failed to retrieve expense lines, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        }
      }

      setIsLoading(false);
    }

    fetchData();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Box>
        {!isLoading && details && (
          <VendorsDetails
            vendorDetails={details.vendorInfo}
            vendorHistory={props.vendorHistory}
            history={props.history}
            voucherSummaries={props.voucherSummaries}
            expenseLines={props.expenseLines}
            vendorAuthNotes={props.vendorAuthNotes}
            vendorContacts={details.contacts}
            vendorDocuments={details.attachments}
            vendorBanks={details.banks}
            vendorAddress={details.addresses}
            vendorDesignations={details.designations}
            location={props.location}
            enumerations={props.enumerations}
            score={details.surveyAverageScore}
          />
        )}
        {isLoading && <FullscreenSpinner />}
      </Box>
    </ThemeProvider>
  );
};

VendorDetailsView.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const {
    authorizations: { vendors, vendorDetails, vendorHistory, vendorAuthNotes, isLoading }
  } = state;
  const { voucherSummaries, expenseLines } = state.expenses;
  const enumerations = state.enumerations;

  return {
    vendors,
    vendorDetails,
    vendorHistory,
    vendorAuthNotes,
    voucherSummaries,
    expenseLines,
    isLoading,
    enumerations
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getVendorDetails,
    setVendorId,
    getVendorHistory,
    getAllVendorAuthNotes,
    getExpenseLines: getExpenseLineItems,
    getVoucherSummaries,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries,
    showToast
  })
)(VendorDetailsView);
